module.exports = __webpack_public_path__ + "img/drops-bg2.abead711.webp";